export enum ClusterCostType {
  HCC = 'HighCost',
  BCC = 'BestCost'
}
